module.exports = __webpack_public_path__ + "static/media/bg.11180cb5.svg";